import { Link } from "react-router-dom";
import { Lock } from "lucide-react";

// Global footer — appears on every page. Reinforces ownership + IP protection.
export default function Footer() {
  return (
    <footer
      data-testid="global-footer"
      className="mt-12 border-t border-black/[0.08] bg-[#f5f5f7] text-[#6e6e73]"
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-5 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
        <div className="flex items-start gap-2 text-[11px] leading-snug">
          <Lock size={12} className="text-[#bf6800] mt-0.5 flex-shrink-0" />
          <p data-testid="footer-copyright" className="font-medium">
            © 2026 Jatinder Singh. Domi-Ops. All rights reserved.
            Proprietary software. Unauthorised copying or use is strictly prohibited.
          </p>
        </div>
        <Link
          to="/terms"
          data-testid="footer-terms-link"
          className="text-[11px] font-bold uppercase tracking-wider text-[#bf6800] hover:text-[#0071e3] transition-colors whitespace-nowrap"
          style={{ fontFamily: "Inter, sans-serif" }}
        >
          Terms of Use →
        </Link>
      </div>
    </footer>
  );
}
